<div class="container" role="main">
  <div class="HmsContainer">
    <form class="questionsForm" [formGroup]="questionsForm">
      <div class="row">
        <div class="row HmsInsideContainer">
          <div class="col-md-12 button-padding-left-custom">
            <button type="button" class="greyBtn" (click)="back()"  style="font-weight : bold;">Go to Previous Section</button>
            <button type="button" class="greyBtn ml-2" (click)="openInstruction()"
              style="margin-left: 1rem;font-weight : bold;"><b>Instructions</b></button>
              <button type="button" class="orangeBtn ml-2" (click)="submitQuestions()" [disabled]="!isFormValid"
                [ngStyle]="{'background-color': isFormValid ? primaryColor : 'gray'}">Proceed to Next Session
              </button>
            </div>
          </div>
          <div class="row HmsInsideContainer py-0">
            <div class="col-md-12 button-padding-left-custom">
              <p role="heading" aria-level="1">Please respond to the questions below and enter any required information.</p>
            </div>
          </div>
        </div>
        <div class="row HmsInsideContainer">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 button-padding-left">
            @if (questionsFormData && questionsFormData.controls && questionsFormData.controls.length > 0) {
              <app-json-form
                [controlsData]="questionsFormData.controls" [formData]="questionsForm" [controlWidth]="true" [isQuePage]="true"
              [customClass]="'controlPadding'" (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
            }

            @if (IsUploadAttatchment) {
              <app-upload-file [showUploadSection]="true"></app-upload-file>
            }
          </div>
        </div>
        <div class="row HmsInsideContainer" >
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <button type="button" class="orangeBtn pull-right" (click)="submitQuestions()" [disabled]="!isFormValid"
              [ngStyle]="{'background-color': isFormValid ? primaryColor : 'gray'}">Proceed to Next Session
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>